<script>
    import { required, minLength, numeric } from "vuelidate/lib/validators";
    import validationMessages from '@/components/validations'
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import Games from "@/services/Games";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    export default {
        props: ["pollData","groupOptions"],
        components:{
            validationMessages , vueDropzone: vue2Dropzone,flatPickr
        },
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                question:'',
                active_from:'',
                active_to:'',
                answers: [{ answer: "" }],
                min_answers: 0,
                image_url: "",
                pollId:null,
                active_to_time:'',
                active_from_time: '',
                photoDeletedCompanyImage : false ,
                photoDeletedLogoUrl : false ,
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                verified_checked: true,
                photoDeleted:false,
                imageStatus:false,
                recipient: '',
                selected_group_id: '',
                audienceOptions: [
                  { value: 'ALL', text: 'All users' },
                  { value: 'GROUP', text: 'User segment(group)' },
                ],
                datetimeconfig: {
                  enableTime: true,
                  time_24hr: true,
                  minuteIncrement: 1,
                  dateFormat: "Y-m-d H:i:S",
                },
                dropzoneOptions_primary: {
                    url: '/',
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    thumbnailWidth: 200,
                    thumbnailMethod: 'contain',
                    maxFilesize: 4,
                    acceptedFiles: 'image/jpeg,image/png,image/gif,image/bmp,image/webp',
                    maxFiles: 3,
                },
                dateconfig: {
                enableTime: false,
                dateFormat: "Y-m-d",
                minDate: new Date(),
              },
              timeconfig: {
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                minuteIncrement: 1,
                dateFormat: "H:i",
              },
            };
        },
            validations: {
               question:{
                 required
               },
              active_from:{
                 required
              },
              active_from_time: {
                required
              },
              active_to:{
                 required
              },
                 active_to_time: {
                required
              },

            },
        computed: {
          hasGroupSelection() {
            return this.recipient === 'GROUP'
          },
        },
        methods: {
          syncData(){
            this.pollId = this.pollData.id;
            this.question = this.pollData.question;
            this.active_from = this.pollData.active_from;
            this.active_from_time = this.pollData.active_from.split(" ")[1];
            this.active_to_time = this.pollData.active_to.split(" ")[1];
            this.active_to = this.pollData.active_to;
            this.min_answers = this.pollData.min_answers;
            this.image_url = this.pollData.image;
            this.recipient = this.pollData.recipient;
            this.selected_group_id = this.pollData.group_id
            if(this.image_url === '' || this.image_url === null || this.image_url === undefined){
              this.photoDeleted = true;
            }

          },
          openDatePicker() {
            this.$refs.datePicker.$el.click();
          },
            openTimePicker() {
            this.$refs.timePicker.$el.click();
          },

            async addPoll(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                } else {
                   const formData = new FormData();
                   formData.append('question', this.question);
                   formData.append('active_from', `${this.active_from} ${this.active_from_time}:00`);
                   formData.append('active_to', `${this.active_to} ${this.active_to_time}:00`);
                   formData.append('min_answers', this.min_answers);
                   formData.append('image', this.image_url);
                   formData.append('recipient', this.recipient);
                   if(this.hasGroupSelection){
                     formData.append('group_id', this.selected_group_id);
                   }else{
                   formData.append('group_id', '');
                   }
                   formData.append('csrf_token', this.csrf_token);
                   formData.append('_method', 'PATCH');
                    try {
                        await Games.editPoll(this.pollId,formData).then((response) => {
                            this.successmsg("Changes has been saved");
                            this.closeModal();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error)
                        }).finally(() => {
                            this.refreshData();
                            this.tryingToEdit = false
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg(this.error)
                    }
                }
                this.tryingToEdit = false;
            },
            selectFileImageUrl(files) {
                setTimeout(() => {
                    let queuedFiles = this.$refs.myVueDropzone_image_url.getQueuedFiles();
                    if (queuedFiles.length > 1) {
                        this.failedmsg('You can only have one logo url');

                        files.forEach((value) => {
                            this.$refs.myVueDropzone_image_url.removeFile(value);
                        });


                    }
                    this.image_url = queuedFiles[0] || null;
                    this.photoDeleted = true;
                }, 250);
            },
            refreshData() {
                this.$emit('onRefresh')
            },
          closeModal() {
                this.showModal = false;
                this.resetProps()
            },
            deleteImage(){
              this.photoDeleted = true;
              this.image_url = "";
            },
            resetProps(){
                this.question = '';
                this.active_from = '';
                this.active_to = '';
                this.active_to_time = ''
                this.active_from_time = ''
                this.min_answers = 0;
                this.image_url = '';
                this.submitted = false;
                this.photoDeleted = false;
                this.recipient = '';
              this.selected_group_id = '';
            }
        },
    };
</script>

<template>
    <b-modal v-model="showModal" @shown="syncData" @hidden="resetProps"  id="edit_poll" title="Edit Poll Question" title-class="font-18" size="lg" centered>
     
      <template v-slot:modal-header>
        <div class="w-100">
          <h5 class="modal-title mb-0">Edit Poll Question</h5>
        </div>
        <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
      </template>

        <form @submit.prevent="addPoll">

        <div class="card mb-3">
          <div class="card-body py-3">
          <header >
            <h4 class="card-title">Recipients</h4>
            <p class="text-muted mb-3">Choose who can see this poll</p>
          </header>

          <b-form-group
            label="Target audience *"
            label-for="giveaway-target-audience"
            class="mb-0"
          >
            <b-form-select
              id="giveaway-target-audience"
              v-model="recipient"
              :options="audienceOptions"
            />
          </b-form-group>

          <b-form-group
            v-if="hasGroupSelection"
            label="User segment *"
            class="mt-4 mb-0"
          >
            <b-form-select
              v-model="selected_group_id"
              :options="groupOptions"
              placeholder="Select user segment"
            />
          </b-form-group>
          </div>
         
        </div>


          <div class="card mb-3">
            <div class="card-body py-3">
              <h4 class="card-title mb-1">Poll Question</h4>
              <p class="text-muted mb-3">Enter your poll question and select the date and time</p>
                <b-form-group label-for="formrow-external-input" class="mb-3">
                  <label for="name">Poll Question*</label>
                  <b-form-input
                      v-model.trim="question"
                      type="text"
                      id="question"
                      aria-describedby="question-feedback"
                      :class="{
                        'is-invalid': submitted && $v.question.$error,
                      }"
                  >
                  </b-form-input>
                  <validationMessages v-if="submitted" :fieldName="'Poll Question'" :validationName="$v.question"></validationMessages>
                </b-form-group>

                <div class="row">
                  <div class="col-6">
                    <label class="mb-1">
                      <i class="uil uil-calendar-alt me-1"></i>Active From Date*
                    </label>
                    <div class="position-relative">
                      <flat-pickr
                          ref="datePickerFrom"
                          v-model="active_from"
                          :config="dateconfig"
                          class="form-control pe-4"
                          name="date"
                          :class="{
                              'is-invalid': submitted && $v.active_from.$error,
                          }"
                      />
                      <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                         style="cursor: pointer; pointer-events: all;"
                         @click="openDatePicker"></i>
                    </div>
                    <validationMessages
                        v-if="submitted"
                        :fieldName="'Active From'"
                        :validationName="$v.active_from"
                    ></validationMessages>
                  </div>
                  <div class="col-6">
                    <label class="mb-1">
                      <i class="uil uil-clock me-1"></i>Active From Time *
                    </label>
                    <div class="position-relative">
                      <flat-pickr
                          ref="timePicker"
                          v-model="active_from_time"
                          :config="timeconfig"
                          class="form-control pe-4"
                          name="time"
                          :class="{
                              'is-invalid': submitted && $v.active_from_time.$error,
                          }"
                      />
                      <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                         style="cursor: pointer; pointer-events: all;"
                         @click="openTimePicker"></i>
                      <validationMessages
                          v-if="submitted"
                          :fieldName="'Active From Time'"
                          :validationName="$v.active_from_time"
                      ></validationMessages>
                    </div>
                  </div>
                </div>
                      <!-- DATE/TIME TO  -->
                <div class="row">
                  <div class="col-6">
                    <label class="mb-1">
                      <i class="uil uil-calendar-alt me-1"></i>Active To Date*
                    </label>
                    <div class="position-relative">
                      <flat-pickr
                          ref="datePickerTo"
                          v-model="active_to"
                          :config="dateconfig"
                          class="form-control pe-4"
                          name="date"
                          :class="{
                              'is-invalid': submitted && $v.active_to.$error,
                          }"
                      />
                      <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                         style="cursor: pointer; pointer-events: all;"
                         @click="openDatePicker"></i>
                    </div>
                    <validationMessages
                        v-if="submitted"
                        :fieldName="'Active To'"
                        :validationName="$v.active_to"
                    ></validationMessages>
                  </div>

                  <div class="col-6">
                    <label class="mb-1">
                      <i class="uil uil-clock me-1"></i>Active To Time *
                    </label>
                    <div class="position-relative">
                      <flat-pickr
                          ref="timePicker"
                          v-model="active_to_time"
                          :config="timeconfig"
                          class="form-control pe-4"
                          name="time"
                          :class="{
                              'is-invalid': submitted && $v.active_to_time.$error,
                          }"
                      />
                      <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                         style="cursor: pointer; pointer-events: all;"
                         @click="openTimePicker"></i>
                      <validationMessages
                          v-if="submitted"
                          :fieldName="'Active To Time'"
                          :validationName="$v.active_to_time"
                      ></validationMessages>
                    </div>
                  </div>

                </div>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-body py-3">
              <div class="form-group d-flex flex-column" >
                <label for="image_url"><i class="uil uil-image me-2"></i>Poll Image: (Max size:4 MB)</label>
                <div v-if="!photoDeleted" class="d-flex align-items-center justify-content-center w-100 flex-column">
                  <img style="width:200px !important; text-align: center;" :src="this.image_url" />
                  <i @click="deleteImage()" class="cursor-pointer uil uil-trash-alt font-size-18 text-danger"></i>
                </div>
                <template v-else>
                
                  <vue-dropzone
                      id="image_url"
                      ref="myVueDropzone_image_url"
                      :use-custom-slot="true"
                      :options="dropzoneOptions_primary"
                      @vdropzone-files-added="selectFileImageUrl"
                      no-progress-bar
                  >
                    <div class="dropzone-custom-content">
                      <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                      <h4>Drag and drop an image, or click to browse</h4>
                      <div class="text-muted mb-3" style="font-size: 13px;">
                        PNG, JPEG, BMP, WEBP up to 4MB
                      </div>
                    </div>
                  </vue-dropzone>
                </template>

              </div>
            </div>
          </div>

          <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="addPoll" :disabled="tryingToEdit">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Submit</b-button>
        </template>
    </b-modal>
</template>